import Api from '@/services/api.js';

export default {
  addSpoil(details) {
    return Api.post('spoils/', details);
  },
  getAllSpoils() {
    return Api.get('spoils/');
  },
  deleteSpoil(spoil) {
    return Api.delete(`spoils/${spoil}`);
  },
  updateSpoil(spoil) {
    var spoilId = spoil.id;
    return Api.put(`spoils/${spoilId}`, spoil);
  },
  getSpoilsByContractor(contractor) {
    return Api.get('spoils/byContractor/' + contractor);
  },
}